import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { Label } from '@r1-frontend/ui-react/components/label';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const FullPreviewWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: fit-content;
`;

export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: fit-content;

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
`;

export const Image = styled(LazyLoadImage)`
    position: relative;
    width: 75%;
    max-width: 480px;
    height: fit-content;
    height: auto;
    margin: 10px auto;
`;

export const FullPreview = styled(LazyLoadImage)`
    transition: opacity 0.3s ease;
    width: 61%;
    margin: 38px auto;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 61%;
        margin: 32px auto;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 64%;
        margin: 16px auto;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 67%;
        min-width: 480px;
        margin: 15px auto;
    }
`;

export const LabelsContainer = styled.div`
    position: absolute;
    gap: 8px;
    top: -12px;
    left: 0;
    z-index: 1;

    @media (max-width: ${wideBreakpoints.mobile}) {
        left: 16px;
        top: -16px;
    }
`;

export const StyledLabel = styled(Label)`
    padding: 4px 8px;
`;

export const FullPreviewContainer = styled.div`
    position: relative;
    width: 100%;
    height: fit-content;
    margin-bottom: 77px;

    .slider .slider-control-bottomcenter {
        position: relative !important;
        bottom: 0px !important;;
    }
`;

export const StyledNukaCarousel = styled(NukaCarousel)`
    padding: 4px 8px;
    height: 100%;
`;

export const CaruselContainer = styled.div`
    margin-bottom: -110px;
    height: 112px;
    width: max-content;
    gap: 8px;
`;

export const ContainerPreview = styled.div`
    height: 52px;
    width: 78px;
`;

export const Preview = styled.div<{ url: string, active?: boolean }>`
    background: no-repeat center / cover url("${p => p.url}") ${COLORS.BgMain};
    border: 1px solid ${p => p.active ? COLORS.GRAY_DARK : COLORS.GRAY_LIGHT};
    border-radius: 4px;
    height: 52px;
    width: 78px;
    cursor: pointer;
`;
